export const PhoneLength = 10;
export const maxLength = 50;
export const maxEmailLength = 255;
export const maxPasswordLength = 255;
